import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=6f70601b&scoped=true"
import script from "./NotificationPopup.vue?vue&type=script&lang=js"
export * from "./NotificationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f70601b",
  null
  
)

export default component.exports